import React from 'react';
import { BarChart3Icon, GlobeIcon, LayersIcon, LayoutDashboardIcon, ShieldCheckIcon } from 'lucide-react';
import { PAD, Reveal, SlideFrame, SlideHeader, t } from './primitives';
import { BrowserFrame, Sparkline, StatusToggle } from './visuals';
const NAV = [{
  label: 'Overview',
  icon: LayoutDashboardIcon,
  active: true
}, {
  label: 'Campaigns',
  icon: LayersIcon,
  active: false
}, {
  label: 'Markets',
  icon: GlobeIcon,
  active: false
}, {
  label: 'Insights',
  icon: BarChart3Icon,
  active: false
}, {
  label: 'Governance',
  icon: ShieldCheckIcon,
  active: false
}];
const KPIS = [{
  value: '34',
  label: 'Live Snaks'
}, {
  value: '27',
  label: 'Markets active'
}, {
  value: '12',
  label: 'Brands'
}, {
  value: '486',
  label: 'Localized assets'
}];
const ROWS = [{
  brand: 'ANZUPGO®',
  campaign: 'Hand eczema patient application guide',
  area: 'Chronic hand eczema',
  market: 'ES · UK · DK',
  on: true,
  trend: [4, 9, 7, 14, 18, 24]
}, {
  brand: 'TraloSpeak',
  campaign: 'KEE webinar series — master Snaks',
  area: 'Atopic dermatitis',
  market: '5 markets',
  on: true,
  trend: [3, 5, 11, 9, 16, 21]
}, {
  brand: 'LEO Pharma CHE',
  campaign: 'Website Snak video embeds',
  area: 'Cross-portfolio',
  market: 'DE · IT pilot',
  on: true,
  trend: [6, 8, 8, 13, 12, 17]
}, {
  brand: 'Travocort®',
  campaign: 'Brand campaign — tranche 2',
  area: 'Topical steroids',
  market: 'DK · CH',
  on: false,
  trend: [9, 7, 6, 5, 4, 4]
}];
const PLATFORM = ['A cross-brand, cross-region dashboard for every Snak and campaign in LEO', 'Live and historical activity across brands, countries, and therapeutic areas', 'A control layer for oversight, campaign visibility, and on/off control'];
export function ControlTower() {
  return <SlideFrame data-id="element-21" data-mp="2xcnt8fpt9kf8">
      <div className={`flex h-full w-full flex-col ${PAD}`} data-id="element-22" data-mp="2xc5m2o1m1lsj">
        <SlideHeader eyebrow="09 — Platform" title="Control Tower —" accent="the enterprise platform" kicker="Snakker for LEO Pharma" data-id="element-23" data-mp="3260d6cjjp31n" />

        <Reveal delay={0.2} className="mt-[2.6vh] flex min-h-0 flex-1" data-id="element-24" data-mp="371kxpeo4fvd7">
          <BrowserFrame label="controltower.snakker.com / leo-pharma" className="w-full" data-id="element-25" data-mp="322rinht6rwax">
            <div className="flex h-full min-h-0" data-id="element-26" data-mp="2y1xvwrrhcnjm">
              <nav className="flex w-[15%] shrink-0 flex-col gap-[1vh] border-r border-white/10 bg-white/[0.03] p-[0.8vw]" data-id="element-27" data-mp="2y38xqm1d7l83">
                <span className={`${t.label} mb-[0.4vh] font-semibold uppercase tracking-[0.18em] text-[#A26BFF]`} data-id="element-28" data-mp="2obmr72zz2abo">
                  LEO
                </span>
                {NAV.map(item => {
                const Icon = item.icon;
                return <span key={item.label} className={`${t.label} flex items-center gap-[0.5vw] rounded-[0.3vw] px-[0.5vw] py-[0.8vh] ${item.active ? 'bg-[#7D38E5]/25 text-white' : 'text-white/45'}`} data-id="element-29" data-mp="2abbz5wmxepox">
                      <Icon aria-hidden className="h-[clamp(8px,1vw,20px)] w-[clamp(8px,1vw,20px)] shrink-0" data-id="element-30" data-mp="psrqsio7mwil" />
                      <span className="truncate" data-id="element-31" data-mp="ytz9vti5nqs3">{item.label}</span>
                    </span>;
              })}
              </nav>

              <div className="flex min-h-0 flex-1 flex-col p-[1vw]" data-id="element-32" data-mp="25jli0qs7ngk">
                <div className="flex shrink-0 items-center justify-between" data-id="element-33" data-mp="64sgf8xk5rdp">
                  <p className={`${t.small} font-semibold text-white`} data-id="element-34" data-mp="b4wvcuitie1t">
                    All Snaks — global overview
                  </p>
                  <span className="flex gap-[0.5vw]" data-id="element-35" data-mp="fw537m4i1rcv">
                    {['Brand', 'Region', 'Therapeutic area', 'Status'].map(chip => <span key={chip} className={`${t.label} rounded-full border border-white/15 px-[0.8vw] py-[0.5vh] text-white/45`} data-id="element-36" data-mp="3jkgjxg8jn8aj">
                        {chip}
                      </span>)}
                  </span>
                </div>

                <div className="mt-[1.6vh] grid shrink-0 grid-cols-4 gap-[0.8vw]" data-id="element-37" data-mp="1yv32oflk356y">
                  {KPIS.map(kpi => <div key={kpi.label} className="rounded-[0.4vw] border border-white/10 bg-white/[0.05] px-[1vw] py-[1.2vh]" data-id="element-38" data-mp="1u1rvuegquof1">
                      <p className={`${t.lead} font-semibold leading-none tracking-[-0.02em] text-white`} data-id="element-39" data-mp="23smfrc6ipbxb">
                        {kpi.value}
                      </p>
                      <p className={`${t.label} mt-[0.9vh] text-white/45`} data-id="element-40" data-mp="2dp7ly0u9wt2q">
                        {kpi.label}
                      </p>
                    </div>)}
                </div>

                <div className="mt-[1.8vh] flex min-h-0 flex-1 flex-col" data-id="element-41" data-mp="jfdsbe386kmy">
                  <div className={`${t.label} grid shrink-0 grid-cols-[1fr_2.1fr_1.2fr_1fr_0.5fr_0.7fr] items-center gap-[0.8vw] border-b border-white/10 pb-[0.8vh] uppercase tracking-[0.14em] text-white/35`} data-id="element-42" data-mp="99w08cwzuazu">
                    <span data-id="element-43" data-mp="4idxpkfbo2cr">Brand</span>
                    <span data-id="element-44" data-mp="4hclhcmkl9tg">Campaign</span>
                    <span data-id="element-45" data-mp="4gazid40n2wy">Therapeutic area</span>
                    <span data-id="element-46" data-mp="3lpps23j4nhjq">Markets</span>
                    <span data-id="element-47" data-mp="3lsvlfuysh5l9">Live</span>
                    <span data-id="element-48" data-mp="3qqdj2p7cvydy">30 days</span>
                  </div>
                  {ROWS.map(row => <div key={row.campaign} className={`${t.small} grid min-h-0 flex-1 grid-cols-[1fr_2.1fr_1.2fr_1fr_0.5fr_0.7fr] items-center gap-[0.8vw] border-b border-white/[0.06] text-white/70`} data-id="element-49" data-mp="3cqmcvan2zmai">
                      <span className="truncate font-semibold text-white" data-id="element-50" data-mp="1awvf8jdwoea2">
                        {row.brand}
                      </span>
                      <span className="truncate" data-id="element-51" data-mp="1dje51fbeez8y">{row.campaign}</span>
                      <span className="truncate text-white/45" data-id="element-52" data-mp="19hkdbwj6l5kx">{row.area}</span>
                      <span className="truncate text-white/45" data-id="element-53" data-mp="19jx1irfj8c6f">{row.market}</span>
                      <StatusToggle on={row.on} data-id="element-54" data-mp="14ipuiul7rh0t" />
                      <Sparkline points={row.trend} className="h-[42%] w-full opacity-80" data-id="element-55" data-mp="zjwcqpyw93uu" />
                    </div>)}
                </div>
              </div>
            </div>
          </BrowserFrame>
        </Reveal>

        <Reveal delay={0.36} className="mt-[2.4vh] grid shrink-0 grid-cols-3 gap-[1.6vw] border-t border-white/10 pt-[2.2vh]" data-id="element-56" data-mp="1ngjygu7hj2cc">
          {PLATFORM.map(item => <p key={item} className={`${t.body} flex gap-[0.7vw] leading-[1.35] text-white/80`} data-id="element-57" data-mp="2fy4rhydfa8vx">
              <span aria-hidden className="mt-[0.7em] h-[2px] w-[1.1vw] shrink-0 bg-[#7D38E5]" data-id="element-58" data-mp="2b5bmrahyf0ju" />
              <span data-id="element-59" data-mp="2ngvtpzxqa8ya">{item}</span>
            </p>)}
        </Reveal>
      </div>
    </SlideFrame>;
}